import React from 'react';

interface ZoominfoIconProps {
  height?: number;
  className?: string;
}

export const ZoominfoLogo: React.FC<ZoominfoIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 16.933 16.933"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g transform="translate(-12.911400, -171.181710)">
        <path
          d="m 12.9114,173.29838 c 0,-1.16901 0.947663,-2.11667 2.116667,-2.11667 h 12.699999 c 1.169009,0 2.116667,0.94766 2.116667,2.11667 v 12.7 c 0,1.16901 -0.947658,2.11666 -2.116667,2.11666 H 15.028067 c -1.169004,0 -2.116667,-0.94765 -2.116667,-2.11666 z"
          fill="#ea1b15"
        />
        <path
          d="m 24.553093,175.41504 h 0.909373 c 0.08247,0 0.14896,0.0665 0.14896,0.14902 v 2.34516 c 0,0.0825 -0.06384,0.14901 -0.146288,0.15166 h -0.763085 c -0.08247,0 -0.14896,-0.0665 -0.14896,-0.14899 v -0.68609 l -5.882878,5.5976 h 1.500558 c 0.08247,0 0.14896,0.0665 0.14896,0.14899 v 0.76033 c 0,0.0825 -0.06649,0.14902 -0.14896,0.14902 h -2.877079 c -0.08247,0 -0.148961,-0.0665 -0.148961,-0.14902 v -0.90932 l 6.668347,-6.35002 h -0.698527 c -0.08247,0 -0.14896,-0.0665 -0.14896,-0.14902 v -0.75766 c 0,-0.0825 0.06649,-0.14898 0.14896,-0.14898 z m -5.291693,1.05834 2.496899,-0.003 c 0.08244,0 0.148961,-0.0665 0.148961,-0.14901 v -0.75766 c 0,-0.0825 -0.06652,-0.14902 -0.146315,-0.14902 h -4.461933 c -0.08247,0 -0.148961,0.0665 -0.148961,0.14902 v 2.34783 c 0,0.0825 0.06649,0.14899 0.148961,0.14899 h 0.757766 c 0.08244,0 0.146289,-0.0665 0.146289,-0.14899 v -1.43851 z m 5.291693,6.35002 h -3.026066 c -0.08244,0 -0.14896,0.0665 -0.14896,0.14899 v 0.76033 c 0,0.0825 0.06652,0.14902 0.14896,0.14902 h 3.935439 c 0.08247,0 0.14896,-0.0665 0.14896,-0.14902 v -2.36021 c 0,-0.0825 -0.06649,-0.14902 -0.14896,-0.14902 h -0.760413 c -0.08247,0 -0.14896,0.0665 -0.14896,0.14902 z"
          fill="#ffffff"
        />
      </g>
    </svg>
  );
};
